import React, {useEffect} from "react";
import {Link} from "react-router-dom";
import $ from "jquery";
import PerfectScrollbar from "perfect-scrollbar";
const Sidebar = () => {

    useEffect(() => {
        const psSidebar = new PerfectScrollbar('#sidebarMenu', {
            suppressScrollX: true
        });

        $('.sidebar .nav-label').on('click', function(e){
            e.preventDefault();

            var target = $(this).next('.nav-sidebar');
            $(target).slideToggle(function(){
                psSidebar.update();
            });

        });

        $('.sidebar .has-sub').on('click', function(e){
            e.preventDefault();

            var target = $(this).next('.nav-sub');
            $(target).slideToggle(function(){
                psSidebar.update();
            });

            var siblings = $(this).closest('.nav-item').siblings();
            siblings.each(function(){
                var nav = $(this).find('.nav-sub');
                if(nav.is(':visible')) {
                    nav.slideUp();
                }
            });
        });

    }, []);


    return (
        <div className="sidebar">
            <div className="sidebar-header">
                <a href="/" className="sidebar-logo">ERRATIC</a>
            </div>
            <div id="sidebarMenu" className="sidebar-body">
                <div className="nav-group show">
                    <a href="#" className="nav-label">Dashboard</a>
                    <ul className="nav nav-sidebar">
                        <li className="nav-item">
                            <Link to={'/'} className="nav-link"><i className="ri-line-chart-line"></i> <span>Dashboard</span></Link>
                        </li>
                    </ul>
                    <a href="#" className="nav-label">Inventory</a>
                    <ul className="nav nav-sidebar">
                        <li className="nav-item">
                            <a href="#" className="nav-link has-sub"><i className="ri-shopping-bag-line"></i> <span>Product Management</span></a>
                            <nav className="nav nav-sub">
                                <Link to={'/products/add'} className="nav-sub-link">Add Product</Link>
                                <Link to={'/products'} className="nav-sub-link">All Products</Link>
                            </nav>
                        </li>
                    </ul>
                    <a href="#" className="nav-label">User</a>
                    <ul className="nav nav-sidebar">
                        <li className="nav-item">
                            <a href="#" className="nav-link has-sub"><i className="ri-user-3-line"></i> <span>User Management</span></a>
                            <nav className="nav nav-sub">
                                <Link to={'/users/add'} className="nav-sub-link">Add User</Link>
                                <Link to={'/users'} className="nav-sub-link">All Users</Link>
                            </nav>
                        </li>
                        <li className="nav-item">
                            <a href="#" className="nav-link has-sub"><i className="ri-qr-code-line"></i> <span>Card Management</span></a>
                            <nav className="nav nav-sub">
                                {/*<Link to={'/cards/add'} className="nav-sub-link">Add Card</Link>*/}
                                <Link to={'/cards'} className="nav-sub-link">All Cards</Link>
                            </nav>
                        </li>
                    </ul>
                    <a href="#" className="nav-label">Settings</a>
                    <ul className="nav nav-sidebar">
                        <li className="nav-item">
                            <a href="#" className="nav-link has-sub"><i className="ri-settings-2-line"></i> <span>Config Management</span></a>
                            <nav className="nav nav-sub">
                                <Link to={'/configs'} className="nav-sub-link">Manage Configuration</Link>
                            </nav>
                        </li>
                    </ul>
                    <a href="#" className="nav-label">Sales</a>
                    <ul className="nav nav-sidebar">
                        <li className="nav-item">
                            <a href="#" className="nav-link has-sub"><i className="ri-shopping-cart-2-line"></i> <span>Order Management</span></a>
                            <nav className="nav nav-sub">
                                <Link to={'/orders'} className="nav-sub-link">All Orders</Link>
                            </nav>
                        </li>
                    </ul>
                </div>
            </div>

        </div>

    );
};

export default Sidebar;
